/**
 * Input Sanitization Utility
 * Provides functions to sanitize user inputs to prevent XSS attacks
 * Lightweight implementation without external dependencies
 */

/**
 * Sanitize plain text input — removes control characters and trims
 * @param input - The input string to sanitize
 * @returns Sanitized string safe for use
 */
export function sanitizeInput(input: string): string {
  if (typeof input !== 'string') {
    return '';
  }

  // eslint-disable-next-line no-control-regex
  let sanitized = input.replace(/[\x00-\x1F\x7F]/g, '');

  // Trim whitespace
  sanitized = sanitized.trim();

  return sanitized;
}

/**
 * Sanitize and validate email address
 * @param email - The email to sanitize
 * @returns Sanitized email or empty string if invalid
 */
export function sanitizeEmail(email: string): string {
  if (typeof email !== 'string') {
    return '';
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const sanitized = email.trim().toLowerCase();

  if (emailRegex.test(sanitized)) {
    return sanitizeInput(sanitized);
  }

  return '';
}
